import script from "./SuperadminBillingView.vue?vue&type=script&setup=true&lang=js"
export * from "./SuperadminBillingView.vue?vue&type=script&setup=true&lang=js"

import "./SuperadminBillingView.vue?vue&type=style&index=0&id=30cf49b1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30cf49b1"]])

export default __exports__